import { EDITOR_ACCENT } from "../editorUiConstants";

/** Brand and editor accent blues plus a coherent neutral / semantic scale. */
export const EDITOR_COLOR_SWATCHES = [
  EDITOR_ACCENT,
  "#082d63",
  "#051d42",
  "#1565c0",
  "#1976d2",
  "#42a5f5",
  "#90caf9",
  "#dbeafe",
  "#ffffff",
  "#f8fafc",
  "#e2e8f0",
  "#94a3b8",
  "#64748b",
  "#333333",
  "#111827",
  "#16a34a",
  "#b30047",
  "#f59e0b",
];
 